<template>
  <local-dialog
:title="title"
:visible="visible"
:show-close="true"
:fullscreen="false"
:append-to-body="appendToBody"
width="300px"
@close="close">
    <template slot="title">
      <div class="cube-fr-login-title-banner">
        <p>{{ title }}</p>
        <span>用于打印</span>
      </div>
    </template>
    <template slot="content">
      <el-form ref="form" class="cube-fr-login" :model="form" :rules="rules">
        <cube-form-item prop="username" label="账号" :error-msg="error.username" :custom-width="23">
          <el-input
ref="username"
v-model="form.username"
autocomplete="new-password"
placeholder="请输入账号"
            @keyup.enter.native="handleLogin" />
        </cube-form-item>
        <cube-form-item prop="password" label="密码" :error-msg="error.password" :custom-width="23">
          <el-input
ref="password"
v-model="form.password"
autocomplete="new-password"
name="password"
            :type="passwordType"
:placeholder="$t('grid.others.password')"
@keyup.enter.native="handleLogin" />
          <cnd-icon
class="show-password"
:name="passwordType === 'password' ? 'cnd-eyes-close' : 'cnd-eyes'
            "
@click="showPwd('passwordType')" />
        </cube-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <el-button
:loading="loading"
class="cube-fr-login-button"
type="primary"
        @click.native.prevent="handleLogin">
        {{ $t('login.login') }}
      </el-button>
    </template>
  </local-dialog>
</template>
<script>
import localDialog from '../../Dialog/index.js'
import '../../../../lib/styles/components/FinePrint.scss'
export default {
  name: 'FRLogin',
  components: { localDialog },
  props: {
    // 弹窗显隐
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '帆软账号登录'
    }

  },
  data() {
    return {
      loading: false,
      passwordType: 'password',
      form: {
        username: '',
        password: ''
      },
      error: {
        username: '请输入用户账号',
        password: '请输入用户密码'
      },
      rules: {
        username: [
          {
            required: true,
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            trigger: 'blur'
          }
        ]

      }
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        const origin = this.$options.data().form
        this.$set(this, 'form', origin)
        this.$refs.form.resetFields()
        this.loading = false
      }
    }
  },
  methods: {
    hideLoading() {
      this.loading = false
    },
    close() {
      this.handleCancel()
    },
    showPwd(type) {
      this[type] = this[type] === 'password' ? '' : 'password'
      this.$nextTick(() => {
        this.$refs[type] && this.$refs[type].focus()
      })
    },
    handleCancel() {
      this.$emit('cancel', true)
      this.$emit('update:visible', false)
      const origin = this.$options.data().form
      this.$set(this, 'form', origin)
      this.$refs.form.resetFields()
    },
    handleLogin() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true
          this.$emit('login', { ...this.form })
          setTimeout(() => {
            this.hideLoading()
          }, 3 * 1000)
        }
      })
    }
  }
}
</script>
